import React from 'react';

export default function Pagetitle({ title, subtitle }) {
  return (
    <div className="px-2">
      <h1 className="text-lg font-bold text-gray-900 flex items-center gap-2">
        <span className="inline-block w-1.5 h-6 bg-primary rounded-full"></span>
        {title}
      </h1>
      {/* {subtitle && (
        <p className="text-gray-500 mt-1 text-sm">{subtitle}</p>
      )} */}
    </div>
  );
}
